export const designTokens = {
  colors: {
    Background: "var(--color-background, #ffffff)",
    "Background Highlight": "var(--color-background-highlight, #f4f7f7)",
    "Background Super Highlight":
      "var(--color-background-super-highlight, #ff6200)",
    Headline: "var(--color-headline, #111111)",
    "Headline Brand 1": "var(--color-headline-brand-1, #ff6200)",
    "Headline Brand 2": "var(--color-headline-brand-2, #4d7c8d)",
    "Headline Eyebrow": "var(--color-headline-eyebrow, #444444)",
    Subhead: "var(--color-subhead, #444444)",
    "Body Primary": "var(--color-body-primary, #444444)",
    "Body Secondary": "var(--color-body-secondary, #666666)",
    Link: "var(--color-link, #006482)",
    "Link Hover": "var(--color-link-hover, #006482)",
    "Link Pressed": "var(--color-link-pressed, #003c4e)",
    "Link Visited": "var(--color-link-visited, #800080)",
    "Link Visited Hover": "var(--color-link-visited-hover, #800080)",
    "Link Visited Pressed": "var(--color-link-visited-pressed, #510051)",
    "Link Inline Content": "var(--color-link-inline-content, #006482)",
    "Tab Link": "var(--color-tab-link, #111111)",
    "Tab Link Hover": "var(--color-tab-link-hover, #111111)",
    "Tab Link Pressed": "var(--color-tab-link-pressed, #006482)",
    "Tab Link Disabled": "var(--color-tab-link-disabled, #a1a1a1)",
    "Tab Link Selected": "var(--color-tab-link-selected, #111111)",
    "List Item": "var(--color-list-item, #ff6200)",
    "List Item Hover": "var(--color-list-item-hover, #ff9b66)",
    Arrow: "var(--color-arrow, #ff6200)",
    "Arrow Hover": "var(--color-arrow-hover, #111111)",
    "Arrow Active": "var(--color-arrow-active, #003c4e)",
    "Arrow Pressed": "var(--color-arrow-pressed, #a1a1a1)",
    "Arrow Disabled": "var(--color-arrow-disabled, #cccccc)",
    "Orange 400 Graphic": "var(--color-symbol-orange-400-graphic, #ff6200)",
    "Gray 300 Graphic": "var(--color-symbol-gray-300-graphic, #666666)",
    "Blue 200 Graphic": "var(--color-symbol-blue-200-graphic, #00c8dc)",
    "Cool Gray 600 Graphic":
      "var(--color-symbol-cool-gray-600-graphic, #4d7c8d)",
    "Gray 100 Graphic": "var(--color-symbol-gray-100-graphic, #cccccc)",
    "Silver 300 Graphic": "var(--color-symbol-silver-300-graphic, #a0b9b9)",
    "Silver 400 Graphic": "var(--color-symbol-silver-400-graphic, #6e8c96)",
    "Button Primary Fill": "var(--color-button-primary-fill, #111111)",
    "Button Primary Fill Hover":
      "var(--color-button-primary-fill-hover, #ff6200)",
    "Button Primary Fill Pressed":
      "var(--color-button-primary-fill-pressed, #ff9b66)",
    "Button Primary Fill Disabled":
      "var(--color-button-primary-fill-disabled, #a1a1a1)",
    "Button Primary Content": "var(--color-button-primary-content, #ffffff)",
    "Button Primary Content Hover":
      "var(--color-button-primary-content-hover, #111111)",
    "Button Primary Content Pressed":
      "var(--color-button-primary-content-pressed, #111111)",
    "Button Primary Content Disabled":
      "var(--color-button-primary-content-disabled, #ffffff)",
    "Button Secondary Outline":
      "var(--color-button-secondary-outline, #111111)",
    "Button Secondary Outline Hover":
      "var(--color-button-secondary-outline-hover, #ff6200)",
    "Button Secondary Outline Pressed":
      "var(--color-button-secondary-outline-pressed, #ff9b66)",
    "Button Secondary Outline Disabled":
      "var(--color-button-secondary-outline-disabled, #a1a1a1)",
    "Button Secondary Content":
      "var(--color-button-secondary-content, #111111)",
    "Button Secondary Content Hover":
      "var(--color-button-secondary-content-hover, #111111)",
    "Button Secondary Content Pressed":
      "var(--color-button-secondary-content-pressed, #111111)",
    "Button Secondary Content Disabled":
      "var(--color-button-secondary-content-disabled, #a1a1a1)",
    "Button Tertiary Content": "var(--color-button-tertiary-content, #006482)",
    "Button Tertiary Content Hover":
      "var(--color-button-tertiary-content-hover, #006482)",
    "Button Tertiary Content Pressed":
      "var(--color-button-tertiary-content-pressed, #003c4e)",
    "Button Tertiary Content Disabled":
      "var(--color-button-tertiary-content-disabled, #a1a1a1)",
    "Button Tertiary Icon Bg": "var(--color-button-tertiary-icon-bg, #f6f4f1)",
    "Button Tertiary Icon Bg Hover":
      "var(--color-button-tertiary-icon-bg-hover, #f6f4f1)",
    "Button Tertiary Icon Bg Pressed":
      "var(--color-button-tertiary-icon-bg-pressed, #f6f4f1)",
    "Button Tertiary Icon Bg Disabled":
      "var(--color-button-tertiary-icon-bg-disabled, #ffffff)",
    "Button Arrow Outline": "var(--color-button-arrow-outline, #ff6200)",
    "Button Arrow Outline Hover":
      "var(--color-button-arrow-outline-hover, #ff6200)",
    "Button Arrow Outline Pressed":
      "var(--color-button-arrow-outline-pressed, #111111)",
    "Button Arrow Outline Disabled":
      "var(--color-button-arrow-outline-disabled, #cccccc)",
    "Button Arrow Filled": "var(--color-button-arrow-filled, #006482)",
    "Button Arrow Filled Hover":
      "var(--color-button-arrow-filled-hover, #006482)",
    "Button Arrow Filled Pressed":
      "var(--color-button-arrow-filled-pressed, #003c4e)",
    "Button Arrow Filled Disabled":
      "var(--color-button-arrow-filled-disabled, #cccccc)",
    Black: "var(--color-swdc-black, #000000)",
    "Black 600": "var(--color-swdc-black-600, #111111)",
    "Black A30": "var(--color-swdc-black-a30, #0000004c)",
    "Black A20": "var(--color-swdc-black-a20, #00000033)",
    "Black A10": "var(--color-swdc-black-a10, #00000019)",
    "Black A8": "var(--color-swdc-black-a8, #00000014)",
    "Black A4": "var(--color-swdc-black-a4, #0000000a)",
    "Blue 150": "var(--color-swdc-blue-150, #00f3ff)",
    "Blue 200": "var(--color-swdc-blue-200, #00c8dc)",
    "Blue 200 New": "var(--color-swdc-blue-200-new, #22d3ee)",
    "Blue 225": "var(--color-swdc-blue-225, #00c8dc)",
    "Blue 300": "var(--color-swdc-blue-300, #00a0be)",
    "Blue 325": "var(--color-swdc-blue-325, #0055cc)",
    "Blue 350": "var(--color-swdc-blue-350, #0647ff)",
    "Blue 400": "var(--color-swdc-blue-400, #2c61f5)",
    "Blue 400 New": "var(--color-swdc-blue-400-new, #0031ba)",
    "Blue 450": "var(--color-swdc-blue-450, #009ab7)",
    "Blue 500": "var(--color-swdc-blue-500, #006482)",
    "Blue 600": "var(--color-swdc-blue-600, #003c4e)",
    "Blue 650": "var(--color-swdc-blue-650, #003342)",
    "Cool Gray 100": "var(--color-swdc-cool-gray-100, #f4f7f7)",
    "Cool Gray 200": "var(--color-swdc-cool-gray-200, #ebefef)",
    "Cool Gray 400": "var(--color-swdc-cool-gray-400, #c9d8d8)",
    "Cool Gray 600": "var(--color-swdc-cool-gray-600, #4d7c8d)",
    "Cool Gray 700": "var(--color-swdc-cool-gray-700, #416879)",
    "Warm Gray 50": "var(--color-swdc-warm-gray-50, #f6f4f1)",
    "Warm Gray 100": "var(--color-swdc-warm-gray-100, #edebe6)",
    "Warm Gray 150": "var(--color-swdc-warm-gray-150, #d7d3c8)",
    "Warm Gray 175": "var(--color-swdc-warm-gray-175, #b6b2a7)",
    "Warm Gray 200": "var(--color-swdc-warm-gray-200, #8f8b80)",
    "Warm Gray 300": "var(--color-swdc-warm-gray-300, #8c8069)",
    "Warm Gray 450": "var(--color-swdc-warm-gray-450, #666152)",
    "Warm Gray 500": "var(--color-swdc-warm-gray-500, #544f43)",
    "Warm Gray 550": "var(--color-swdc-warm-gray-550, #454137)",
    "Warm Gray 600": "var(--color-swdc-warm-gray-600, #333029)",
    "Gray 50": "var(--color-swdc-gray-50, #eeeeee)",
    "Gray 100": "var(--color-swdc-gray-100, #cccccc)",
    "Gray 200": "var(--color-swdc-gray-200, #a1a1a1)",
    "Gray 250": "var(--color-swdc-gray-250, #767676)",
    "Gray 300": "var(--color-swdc-gray-300, #666666)",
    "Gray 350": "var(--color-swdc-gray-350, #555555)",
    "Gray 400": "var(--color-swdc-gray-400, #444444)",
    "Gray 450": "var(--color-swdc-gray-450, #2e2e2e)",
    "Gray 500": "var(--color-swdc-gray-500, #222222)",
    "Green 200": "var(--color-swdc-green-200, #00f109)",
    "Green 300": "var(--color-swdc-green-300, #aadc33)",
    "Green 300 New": "var(--color-swdc-green-300-new, #34d399)",
    "Green 350": "var(--color-swdc-green-350, #aadc33)",
    "Green 500": "var(--color-swdc-green-500, #7ac400)",
    "Green 725": "var(--color-swdc-green-725, #52a700)",
    "Green 800": "var(--color-swdc-green-800, #408500)",
    "Orange 200": "var(--color-swdc-orange-200, #ff9b66)",
    "Orange 300": "var(--color-swdc-orange-300, #ff8133)",
    "Orange 400": "var(--color-swdc-orange-400, #ff6200)",
    "Purple 100": "var(--color-swdc-purple-100, #d97de4)",
    "Purple 200": "var(--color-swdc-purple-200, #bf4ecd)",
    "Purple 300": "var(--color-swdc-purple-300, #800080)",
    "Purple 500": "var(--color-swdc-purple-500, #510051)",
    "Red 175": "var(--color-swdc-red-175, #f87171)",
    "Red 200": "var(--color-swdc-red-200, #eb686a)",
    "Red 400": "var(--color-swdc-red-400, #e20a38)",
    "Red 500": "var(--color-swdc-red-500, #c6022c)",
    "Red 600": "var(--color-swdc-red-600, #970000)",
    "Silver 200": "var(--color-swdc-silver-200, #d8e3e3)",
    "Silver 300": "var(--color-swdc-silver-300, #a0b9b9)",
    "Silver 400": "var(--color-swdc-silver-400, #6e8c96)",
    White: "var(--color-swdc-white, #ffffff)",
    "Yellow 100": "var(--color-swdc-yellow-100, #fffc00)",
    "Yellow 200": "var(--color-swdc-yellow-200, #f0d671)",
    "Yellow 300": "var(--color-swdc-yellow-300, #fbbf24)",
    "Yellow 400": "var(--color-swdc-yellow-400, #fbdc44)",
    "Semantic Red": "var(--color-swdc-red-200, #eb686a)",
    "Semantic Yellow": "var(--color-swdc-yellow-200, #f0d671)",
  },
  spacing: {
    "2px": "var(--spacing-0.5, 2px)",
    "4px": "var(--spacing-1, 4px)",
    "8px": "var(--spacing-2, 8px)",
    "12px": "var(--spacing-3, 12px)",
    "16px": "var(--spacing-4, 16px)",
    "20px": "var(--spacing-5, 20px)",
    "24px": "var(--spacing-6, 24px)",
    "32px": "var(--spacing-8, 32px)",
    "40px": "var(--spacing-10, 40px)",
    "48px": "var(--spacing-12, 48px)",
    "56px": "var(--spacing-14, 56px)",
    "64px": "var(--spacing-16, 64px)",
    "80px": "var(--spacing-20, 80px)",
    "96px": "var(--spacing-24, 96px)",
    "112px": "var(--spacing-28, 112px)",
  },
  fontFamily: {
    Roboto: 'var(--font-roboto, "Roboto", sans-serif)',
    "Roboto Slab": 'var(--font-roboto-slab, "Roboto Slab", serif)',
    "Roboto Serif": 'var(--font-roboto-serif, "Roboto Serif", serif)',
    "Space Mono": 'var(--font-space-mono, "Space Mono", monospace)',
    Geist: 'var(--font-geist, "Geist", sans-serif)',
  },
  fontSize: {
    "Display - X-Large": "var(--text-display-xl, 6.25rem)",
    "Display - Large": "var(--text-display-l, 5.25rem)",
    "Display - Medium": "var(--text-display-m, 4.375rem)",
    "Display - Small": "var(--text-display-s, 3.75rem)",
    "Headline - X-Large": "var(--text-headline-xl, 3.5rem)",
    "Headline - Large": "var(--text-headline-l, 3rem)",
    "Headline - Medium": "var(--text-headline-m, 2.375rem)",
    "Headline - Small": "var(--text-headline-s, 2.125rem)",
    "Subhead - X-Large": "var(--text-subhead-xl, 1.875rem)",
    "Subhead - Large": "var(--text-subhead-l, 1.75rem)",
    "Subhead - Medium": "var(--text-subhead-m, 1.5rem)",
    "Subhead - Small": "var(--text-subhead-s, 1.375rem)",
    "Subhead - X-Small": "var(--text-subhead-xs, 1.25rem)",
    "Subhead - 2X-Small": "var(--text-subhead-2xs, 1.125rem)",
    "Link - Large": "var(--text-link-l, 1.375rem)",
    "Link - Medium": "var(--text-link-m, 1.125rem)",
    "Link - Small": "var(--text-link-s, 1rem)",
    "Link - X-Small": "var(--text-link-xs, 0.875rem)",
    "Body - Large": "var(--text-body-l, 1.25rem)",
    "Body - Medium": "var(--text-body-m, 1.125rem)",
    "Body - Small": "var(--text-body-s, 1rem)",
    "Body - X-Small": "var(--text-body-xs, 0.875rem)",
    "Body - 2X-Small": "var(--text-body-2xs, 0.75rem)",
  },
  lineHeight: {
    "Display - X-Large": "var(--text-display-xl--line-height, 6.875rem)",
    "Display - Large": "var(--text-display-l--line-height, 5.875rem)",
    "Display - Medium": "var(--text-display-m--line-height, 5rem)",
    "Display - Small": "var(--text-display-s--line-height, 4.25rem)",
    "Headline - X-Large": "var(--text-headline-xl--line-height, 4.125rem)",
    "Headline - Large": "var(--text-headline-l--line-height, 3.75rem)",
    "Headline - Medium": "var(--text-headline-m--line-height, 3rem)",
    "Headline - Small": "var(--text-headline-s--line-height, 2.75rem)",
    "Subhead - X-Large": "var(--text-subhead-xl--line-height, 2.5rem)",
    "Subhead - Large": "var(--text-subhead-l--line-height, 2.375rem)",
    "Subhead - Medium": "var(--text-subhead-m--line-height, 2.25rem)",
    "Subhead - Small": "var(--text-subhead-s--line-height, 2rem)",
    "Subhead - X-Small": "var(--text-subhead-xs--line-height, 1.75rem)",
    "Subhead - 2X-Small": "var(--text-subhead-2xs--line-height, 1.5rem)",
    "Link - Large": "var(--text-link-l--line-height, 2rem)",
    "Link - Medium": "var(--text-link-m--line-height, 1.5rem)",
    "Link - Small": "var(--text-link-s--line-height, 1.25rem)",
    "Link - X-Small": "var(--text-link-xs--line-height, 1.25rem)",
    "Body - Large": "var(--text-body-l--line-height, 2rem)",
    "Body - Medium": "var(--text-body-m--line-height, 2rem)",
    "Body - Small": "var(--text-body-s--line-height, 1.5rem)",
    "Body - X-Small": "var(--text-body-xs--line-height, 1.5rem)",
    "Body - 2X-Small": "var(--text-body-2xs--line-height, 1rem)",
  },
  fontWeight: {
    Black: "var(--font-weight-black, 900)",
    Bold: "var(--font-weight-bold, 700)",
    "Semi Bold": "var(--font-weight-semi-bold, 600)",
    Medium: "var(--font-weight-medium, 500)",
    Normal: "var(--font-weight-normal, 400)",
    Light: "var(--font-weight-light, 300)",
  },
  letterSpacing: {
    Condensed: "var(--tracking-tight, -0.25rem)",
    Normal: "var(--tracking-normal, 0)",
    Wide: "var(--tracking-swdc-wide, 0.0625rem)",
  },
} as const;

const recordToNameValueList = (group: Record<string, string>) => {
  return Object.entries(group).map(([name, value]) => ({ name, value }));
};

export default function registerDesignTokens() {
  if (typeof window === "undefined") {
    return;
  }

  const url = new URL(window.location.href);

  const userPermissions =
    url.searchParams.get("builder.user.permissions")?.split(",") || [];

  // Dynamically import Builder SDK only in the browser to avoid requiring global fetch in Node/Jest
  import("@builder.io/sdk-react").then(({ register }) => {
    register("editor.settings", {
      strictMode: !userPermissions.includes("editCode"),
      allowOverridingTokens: userPermissions.includes("editCode"),
      styleStrictMode: !userPermissions.includes("editCode"),
      designTokens: {
        // @see https://app.zeplin.io/styleguide/671ab6189623ff7a7cdadded/colors
        colors: recordToNameValueList(designTokens.colors),
        // @see https://app.zeplin.io/styleguide/671ab6189623ff7a7cdadded/spacing
        spacing: recordToNameValueList(designTokens.spacing),
        // @see https://app.zeplin.io/styleguide/671ab6189623ff7a7cdadded/textstyles
        fontFamily: recordToNameValueList(designTokens.fontFamily),
        fontSize: recordToNameValueList(designTokens.fontSize),
        lineHeight: recordToNameValueList(designTokens.lineHeight),
        fontWeight: recordToNameValueList(designTokens.fontWeight),
        letterSpacing: recordToNameValueList(designTokens.letterSpacing),
      },
    });
  });
}
